import {
  setAuthLoading,
  setRefreshToken,
  setToken,
  setUser,
  setUserMobileNumber,
} from "../store/auth/authActions";

import Bugsnag from "@bugsnag/js";
import appConfig from "../config";
import axios from "axios";
import { logout } from "../store/indexActions";
import { search } from "./infringement";
import store from "../store";
import { toast } from "react-toastify";

export const register = (
  full_name: string,
  email: string,
  password: string,
  mobile_number: string,
  id_type: string,
  id_number: string,
  terms_status: boolean,
  password_confirmation: string
): any => {
  var data = new FormData();
  const account = store.getState().fine.account;
  data.append("full_name", full_name);
  data.append("email", email.toLowerCase());
  data.append("password", password.trim());
  data.append("mobile_number", mobile_number);
  data.append("id_type", id_type);
  data.append("id_number", id_number);
  data.append("password_confirmation", password_confirmation.trim());
  data.append("terms_status", terms_status ? "1" : "0");
  data.append("account", account ? account : "");

  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/register`,
    headers: {
      Accept: "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      const { status } = response.data;

      if (status && status === "success") {
        return true;
      } else {
        return { registerError: response?.data?.errors?.email[0] };
      }
    })
    .catch(function (error) {
      Bugsnag.notify(new Error(error));
      const { response } = error;
      const { data } = response;
      const { errors } = data;
      return { registerError: errors };
    });
};

export const login = async (username: string, password: string) => {
  store.dispatch(setAuthLoading(true));
  var data = new FormData();
  const account = store.getState().fine.account;

  data.append("grant_type", "password");
  data.append("client_id", appConfig.clientID);
  data.append("client_secret", appConfig.clientSecret);
  data.append("username", username?.toLowerCase().trim());
  data.append("password", password);

  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/oauth/token`,
    headers: {
      ac: "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      const { access_token, refresh_token } = response.data;
      if (access_token) {
        store.dispatch(setToken(access_token));
        store.dispatch(setRefreshToken(refresh_token));

        if (account) {
          search(account).finally(() => {
            getProfile();
          });
        } else {
          getProfile();
        }
      }
      return true;
    })
    .catch(function (error) {
      store.dispatch(setAuthLoading(false));
      Bugsnag.notify(new Error(error));
      return {
        loginError: error?.response?.data?.error_description || error.message,
      };
    });
};

export const getProfile = async (noRedirect?: boolean) => {
  var config = {
    method: "get",
    url: `${appConfig.baseApiUrl}/api/me`,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${store.getState().auth.token}`,
    },
  };

  return axios(config)
    .then(function (response) {
      store.dispatch(setUser(response.data.data));
      if (!response.data.data.is_verified && !noRedirect) {
        let url = window.location.origin;
        url += "/verify?resend_code=true";
        window.location.href = url;
        return false;
      } else if (!noRedirect) {
        if (!store.getState().fine.infringement) {
          window.location.replace("/");
        }
      }
      return true;
    })
    .finally(() => {
      const idFines = store.getState().fine.idFines;
      if (!idFines) store.dispatch(setAuthLoading(false));
    })
    .catch(function (error) {
      store.dispatch(setAuthLoading(false));
      Bugsnag.notify(new Error(error));
      const { response } = error;
      const { data } = response;
      const { message, status } = data;

      if (message === "Unauthenticated.") {
        store.getState().auth.refreshToken && refreshToken();
      }
      if (message && message.includes("not verified")) {
        let url = window.location.origin;
        url += "/verify?resend_code=true";
        window.location.href = url;
      }
      return false;
    });
};

export const forgotPassword = async (email: string) => {
  var FormData = require("form-data");
  var data = new FormData();
  data.append("email", email.toLowerCase());

  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/password/forgot-password`,
    headers: {
      Accept: "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      const { message } = response.data;
      if (message.includes("not"))
        return {
          status: false,
          message: message,
        };
      return {
        status: true,
        message: "success",
      };
    })
    .catch(function (error) {
      Bugsnag.notify(new Error(error));
      console.log(error);
      return {
        status: false,
        message: "Error processing request",
      };
    });
};

export const updatePassword = async (password: string, password_confirmation: string) => {
  const token = store.getState().auth.token;
  var FormData = require("form-data");
  var data = new FormData();
  data.append("password", password.trim());
  data.append("password_confirmation", password_confirmation.trim());

  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/password`,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      return {
        status: true,
      };
    })
    .catch(function (error) {
      const { response } = error;
      const { data } = response;
      const { errors } = data;
      console.log("error body", errors);

      Bugsnag.notify(new Error(error));
      return {
        status: false,
        errors: errors,
      };
    });
};

export const resetPassword = async (
  password: string,
  password_confirmation: string,
  token: string,
  email: string
) => {
  var FormData = require("form-data");
  var data = new FormData();
  data.append("password", password.trim());
  data.append("password_confirmation", password_confirmation.trim());
  data.append("token", token);
  data.append("email", email);

  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/password/reset`,
    headers: {
      Accept: "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      return {
        status: true,
      };
    })
    .catch(function (error) {
      Bugsnag.notify(new Error(error));
      console.log(error);
      const { response } = error;
      const { data } = response;
      const { message } = data;
      return {
        status: false,
        message: message,
      };
    });
};

export const updateProfile = async (email: string, mobile_number: string, verify?: boolean) => {
  const token = store.getState().auth.token;

  var FormData = require("form-data");
  var data = new FormData();
  data.append("email", email.toLowerCase());
  data.append("mobile_number", mobile_number);
  if (verify) {
    data.append("verify", verify);
  }

  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/profile`,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      if (response.data.status) {
        store.dispatch(setUserMobileNumber(response.data.data.mobile_number));
      }
      return { status: true };
    })
    .catch(function (error) {
      const { response } = error;
      const { data } = response;
      const { errors } = response.data;
      Bugsnag.notify(new Error(error));
      console.log(error);
      return { status: false, message: errors?.email[0] };
    });
};

export const verifyEmail = async (url: string) => {
  var config = {
    method: "get",
    url: `${appConfig.baseApiUrl}${url}`,

    headers: {
      Accept: "application/json",
    },
  };

  return axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      Bugsnag.notify(new Error(error));
      const { response } = error;
      const { data } = response;
      const { message } = data;
      if (message && message === "Unauthenticated.") {
        refreshToken();
      }
      const returnValue = {
        status: false,
        message: message !== "Unauthenticated." ? message : "Your email has not been verified",
      };
      return returnValue;
    });
};

export const resendEmailVerification = async (id: string, hash: string) => {
  var data = new FormData();
  data.append("id", id);
  data.append("hash", hash);
  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/email/verify/resend`,
    headers: {},
    data: data,
  };

  return axios(config)
    .then(function (response) {
      const { data } = response;
      const { message, status } = data;
      console.log(data);
      return { message, status };
    })
    .catch(function (error) {
      Bugsnag.notify(new Error(error));
      console.log(error);

      return false;
    });
};

export const refreshToken = async () => {
  var FormData = require("form-data");
  var data = new FormData();
  data.append("grant_type", "refresh_token");
  data.append("client_id", appConfig.clientID);
  data.append("client_secret", appConfig.clientSecret);
  data.append("refresh_token", store.getState().auth.refreshToken);

  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/oauth/token`,
    headers: {},
    data: data,
  };

  return axios(config)
    .then(function (response) {
      const { access_token, refresh_token } = response.data;
      store.dispatch(setToken(access_token));
      store.dispatch(setRefreshToken(refresh_token));
      return access_token;
    })
    .catch(function (error) {
      toast.error("Your session has expired", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setTimeout(() => {
        logout(false);
      }, 2500);
    });
};

export const resetCheck = async (token: string, email: string) => {
  var FormData = require("form-data");
  var data = new FormData();
  data.append("token", token);
  data.append("email", email);

  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/password-reset/check`,
    headers: {
      Accept: "application/json",
    },
    data: data,
  };
  return axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      return {
        status: "error",
        message: "Your link has expired.",
      };
    });
};
